import React from "react";

import { Recommendation } from "../../service/areena-recommendations";
import { LargeEndRecommendations } from "../recommendations/LargeEndRecommendations";
import {
  CommonCardProps,
  UiSize
} from "../recommendations/recommendationTypes";
import { SmallEndRecommendations } from "../recommendations/SmallEndRecommendations";

type Props = {
  recommendations: Recommendation[];
  commonCardProps: CommonCardProps;
  showRecommendations: boolean;
};
export const EndRecommendations = ({
  commonCardProps,
  recommendations,
  showRecommendations
}: Props) => {
  return showRecommendations ? (
    commonCardProps.uiSize === UiSize.Small ? (
      <SmallEndRecommendations {...{ commonCardProps, recommendations }} />
    ) : (
      <LargeEndRecommendations {...{ commonCardProps, recommendations }} />
    )
  ) : null;
};
